module.exports = __webpack_public_path__ + "img/white-horizontal.17182e53.png";